import { fetchTextFile, fetchBinaryFile } from "util/FileDownloadUtils";
import { qualifyUrl } from "util/URLUtils";
import { adjustFormat } from "util/DateTime";
import { WIDGET_WIDTH, WIDGET_MAX_HEIGHT_ASPECT_RATIO, MIN_WIDGET_HEIGHT, WIDGET_ASPECT_RATIO } from "report/Constants";
import { MAXIMUM_GRID_SIZE } from "search/ExportWidgetAction/downloadByExportStrategy";
export const mimeTypeMapper = {
  csv: "text/csv",
  json: "application/json",
  yaml: "application/yaml",
  xml: "application/xml",
  xlsx: "application/vnd.ms-excel",
  pdf: "application/json"
};
export const BinaryFilesExtentions = ["xlsx", "pdf"];
export const escapeFilename = (filename) => {
  if (!filename) {
    return filename;
  }
  const reservedChars = /[<>:/\\|?*%\x00-\x1F,]/g;
  return filename.replace(reservedChars, "_").trim().replace(/[. ]+$/, "");
};
const getUrl = (fileName) => qualifyUrl(`views/search/pivot/export/${escapeFilename(fileName)}`);
const getPdfUrl = () => qualifyUrl("plugins/org.graylog.plugins.widgetexport/widgetexport/export");
const getInvestigationUrl = (fileName) => qualifyUrl(`/plugins/org.graylog.plugins.securityapp.investigations/investigations/export/${fileName}`);
export const exportWidget = (widgetTitle, widgetResults, extension) => {
  var _a, _b;
  const fileName = `${widgetTitle}_${(_a = widgetResults == null ? void 0 : widgetResults.effective_timerange) == null ? void 0 : _a.from}-${(_b = widgetResults == null ? void 0 : widgetResults.effective_timerange) == null ? void 0 : _b.to}.${extension}`;
  const mimeType = mimeTypeMapper[extension];
  if (BinaryFilesExtentions.includes(extension))
    return fetchBinaryFile("POST", getUrl(fileName), widgetResults, mimeType, fileName);
  return fetchTextFile("POST", getUrl(fileName), widgetResults, mimeType, fileName);
};
export const exportPdfWidget = (widgetTitle, widget, widgetResults, extension, exportType) => {
  var _a, _b;
  const fileName = `${widgetTitle}_${(_a = widgetResults == null ? void 0 : widgetResults.effective_timerange) == null ? void 0 : _a.from}-${(_b = widgetResults == null ? void 0 : widgetResults.effective_timerange) == null ? void 0 : _b.to}.${extension}`;
  const mimeType = mimeTypeMapper[extension];
  const requestBody = { widget };
  if (widgetResults && exportType) {
    requestBody.data = { results: widgetResults, type: exportType };
  }
  const requestFn = BinaryFilesExtentions.includes(extension) ? fetchBinaryFile : fetchTextFile;
  return requestFn("POST", getPdfUrl(), requestBody, mimeType, fileName);
};
export const downloadNonPdfInvestigationWidget = (widgetTitle, widget, extension) => {
  const fileName = `${widgetTitle}_${adjustFormat(/* @__PURE__ */ new Date(), "internal")}.${extension}`;
  const mimeType = mimeTypeMapper[extension];
  const requestFn = BinaryFilesExtentions.includes(extension) ? fetchBinaryFile : fetchTextFile;
  const requestBody = {
    filters: widget.config.filters,
    exported_field_names: widget.config.fields.toArray(),
    limit: 1e3,
    sorts: [{ field: widget.config.sort.field, order: widget.config.sort.direction === "Ascending" ? "ASC" : "DESC" }]
  };
  return requestFn("POST", getInvestigationUrl(fileName), requestBody, mimeType, fileName);
};
export const getExportWidgetSizes = (originalHeight, originalWidth, orientation, pageWidth) => {
  const width = pageWidth != null ? pageWidth : WIDGET_WIDTH[orientation];
  const normalizedOriginalWidth = originalWidth === "Infinity" ? MAXIMUM_GRID_SIZE : originalWidth;
  const originalRatio = originalHeight && originalWidth ? Number(originalHeight) / Number(normalizedOriginalWidth) : 1;
  const height = Math.min(originalRatio, WIDGET_MAX_HEIGHT_ASPECT_RATIO[orientation]) * width;
  return { width, height: Math.max(height, MIN_WIDGET_HEIGHT) };
};
export const getWidgetSizesFromUserCustomization = (widgetHeight, orientation, pageWidth) => {
  const width = pageWidth != null ? pageWidth : WIDGET_WIDTH[orientation];
  const maxHeight = WIDGET_MAX_HEIGHT_ASPECT_RATIO[orientation] * width;
  const step = (maxHeight - MIN_WIDGET_HEIGHT) / MAXIMUM_GRID_SIZE;
  const height = MIN_WIDGET_HEIGHT + step * widgetHeight;
  return { width, height: Math.min(height, maxHeight) };
};
const getReportDefaultWidgetSizes = (orientation, defaultWidth) => {
  const _orientation = orientation != null ? orientation : "portrait";
  const width = defaultWidth != null ? defaultWidth : WIDGET_WIDTH[_orientation];
  const height = width * WIDGET_ASPECT_RATIO[_orientation];
  return { width, height };
};
export const getWidgetSizes = (widget, orientation, pageWidth) => {
  if (widget.height) return getWidgetSizesFromUserCustomization(widget.height, orientation, pageWidth);
  return getReportDefaultWidgetSizes(orientation, pageWidth);
};
